import { uploadSingleFile } from "../files";
import { authClient, API } from "../index";

// Get all eventos
export const getEventos = () => {
  return authClient().get(`${API}/evento?getDisabled=true`);
};

// Get evento by id
export const getEventoById = (id) => {
  return authClient().get(`${API}/evento/${id}`);
};

// Delete evento
export const deleteEvento = (id) => {
  return authClient().delete(`${API}/evento/${id}`);
};

// Create evento
export const postEvento = async (evento, selectedImages, selectedFile) => {
  for (let image of selectedImages) {
    const response = await uploadSingleFile(image, "eventos");
    const imageUrl = response?.data?.fileURL;
    evento.imagenes.push(imageUrl);
  }
  if (selectedFile) {
    const response = await uploadSingleFile(selectedFile, "eventos");
    evento.adjunto = response?.data?.fileURL;
  }
  return authClient().post(`${API}/evento`, evento);
};

// Update evento
export const updateEvento = async (
  id,
  evento,
  selectedImages,
  selectedFile
) => {
  for (let image of selectedImages) {
    const response = await uploadSingleFile(image, "eventos");
    const imageUrl = response?.data?.fileURL;
    evento.imagenes.push(imageUrl);
  }
  if (selectedFile) {
    const response = await uploadSingleFile(selectedFile, "eventos");
    evento.adjunto = response?.data?.fileURL;
  }
  return authClient().put(`${API}/evento/${id}`, evento);
};

// Change status evento
export const changeStatusEvento = async (id, active) => {
  return authClient().put(`${API}/evento/change-status/${id}`, { active });
};
